<div fxLayout="column">
    <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
    <div *ngIf="isBrowserIE; else loginOneTimeFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="loginOneTimeFlexColumnTemplate"></ng-container>
    </div>
</div>

<ng-template #loginOneTimeFlexColumnTemplate>
    <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
    <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else loginOneTimeMainFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="loginOneTimeMainFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #loginOneTimeMainFlexColumnTemplate>
    <div fxFlex="50%" fxHide.lt-md></div>
    <div fxFlex="500px" fxFlex.lt-md="100%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px;">
        <div class="display-text normal-paragraph-spacing">
            <mat-card>
                <mat-card-content>
                    <div fxLayout="column">
                        <div *ngIf="isBrowserIE; else loginOneTimeFormFlexColumnTemplate">
                            <ng-container *ngTemplateOutlet="loginOneTimeFormFlexColumnTemplate"></ng-container>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div fxFlex="50%" fxHide.lt-md></div>
</ng-template>

<ng-template #loginOneTimeFormFlexColumnTemplate>
    <div fxLayout="column">
        <div class="display-text primary-dark-color-important">
            <b><span i18n="@@login-one-time.form.title">login-one-time.form.title</span></b>
        </div>
        <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;"></div>
        <div class="display-text">
            <form [formGroup]="loginOneTimeForm">
                <div fxLayout="column">
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing">
                        <b><span i18n="@@login-one-time.form.pre-message">login-one-time.form.pre-message</span></b>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!userVerified">
                            <input matInput i18n-placeholder="@@login-one-time.form.user-name.placeholder"
                                placeholder="login-one-time.form.user-name.placeholder" type="text"
                                [formControl]="userNameFormControl" autocomplete="off"
                                [maxlength]="fieldValidations.userRegistration.userNameMaxLength" required />
                            <mat-error *ngIf="userNameFormControl.hasError('required')"
                                i18n="@@login-one-time.form.error.required">login-one-time.form.error.required</mat-error>
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
                            <input matInput i18n-placeholder="@@login-one-time.form.temporary-password.placeholder"
                                placeholder="login-one-time.form.temporary-password.placeholder" type="password"
                                [formControl]="temporaryPasswordFormControl" autocomplete="off"
                                [maxlength]="fieldValidations.userRegistration.temporaryPasswordMaxLength" required />
                            <mat-hint align="end"
                                i18n="@@login-one-time.form.hint.temporary-password">login-one-time.form.hint.temporary-password</mat-hint>
                            <mat-error *ngIf="temporaryPasswordFormControl.hasError('required')"
                                i18n="@@login-one-time.form.error.required">login-one-time.form.error.required</mat-error>
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                        class="display-text warning-color normal-paragraph-spacing normal-paragraph-pre-spacing"
                        *ngIf="showTemporaryPasswordError">
                        <b><span
                                i18n="@@login-one-time.temporary-password-message.error.1">login-one-time.temporary-password-message.error.1</span></b>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                        class="display-text warning-color normal-paragraph-spacing" *ngIf="showTemporaryPasswordError">
                        <b><span
                                i18n="@@login-one-time.temporary-password-message.error.2">login-one-time.temporary-password-message.error.2</span></b>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                        class="display-text warning-color normal-paragraph-spacing normal-paragraph-pre-spacing"
                        *ngIf="showExpiredTemporaryPasswordError">
                        <b><span
                                i18n="@@login-one-time.expired-temporary-password-message.error.1">login-one-time.expired-temporary-password-message.error.1</span></b>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                        class="display-text warning-color normal-paragraph-spacing"
                        *ngIf="showExpiredTemporaryPasswordError">
                        <b><span
                                i18n="@@login-one-time.expired-temporary-password-message.error.2">login-one-time.expired-temporary-password-message.error.2</span></b>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
                            <input matInput i18n-placeholder="@@login-one-time.form.new-password.placeholder"
                                placeholder="login-one-time.form.new-password.placeholder" type="password"
                                [formControl]="newPasswordFormControl" autocomplete="off"
                                [maxlength]="fieldValidations.userRegistration.passwordMaxLength" required />
                            <mat-hint align="end"
                                i18n="@@login-one-time.form.hint.new-password">login-one-time.form.hint.new-password</mat-hint>
                            <mat-error *ngIf="newPasswordFormControl.hasError('required')"
                                i18n="@@login-one-time.form.error.required">login-one-time.form.error.required</mat-error>
                            <mat-error
                                *ngIf="newPasswordFormControl.hasError('pattern') && !newPasswordFormControl.hasError('required')"
                                i18n="@@login-one-time.form.error.new-password">login-one-time.form.error.new-password</mat-error>
                        </mat-form-field>
                    </div>
                    <br>
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
                            <input matInput i18n-placeholder="@@login-one-time.form.confirm-new-password.placeholder"
                                placeholder="login-one-time.form.confirm-new-password.placeholder" type="password"
                                [formControl]="confirmNewPasswordFormControl" autocomplete="off"
                                [maxlength]="fieldValidations.userRegistration.passwordMaxLength" required />
                            <mat-hint align="end"
                                i18n="@@login-one-time.form.hint.confirm-new-password">login-one-time.form.hint.confirm-new-password</mat-hint>
                            <mat-error *ngIf="confirmNewPasswordFormControl.hasError('required')"
                                i18n="@@login-one-time.form.error.required">login-one-time.form.error.required</mat-error>
                            <mat-error
                                *ngIf="confirmNewPasswordFormControl.hasError('pattern') && !confirmNewPasswordFormControl.hasError('required')"
                                i18n="@@login-one-time.form.error.confirm-new-password">login-one-time.form.error.confirm-new-password</mat-error>
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing"
                        *ngIf="newPasswordEqualsFormControl.invalid && newPasswordEqualsFormControl.hasError('required')">
                        <span ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" fxLayoutAlign="left start">
                            <mat-error class="form-error"
                                *ngIf="newPasswordEqualsFormControl.invalid && newPasswordEqualsFormControl.hasError('required')"
                                i18n="@@login-one-time.form.new-password-equals.error">login-one-time.form.new-password-equals.error</mat-error>
                        </span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center"
                        class="display-text normal-paragraph-spacing normal-paragraph-pre-spacing">
                        <re-captcha formControlName="recaptchaFormControl" siteKey="{{ recaptchaSiteKey }}"
                            required></re-captcha>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing"
                        *ngIf="!showSubmitSpinner && !showLoginButton">
                        <button mat-flat-button color="primary" (click)="submitUser()"
                            i18n="@@login-one-time.form.submit-button.label" [disabled]="!submitEnabled()">
                            login-one-time.form.submit-button.label
                        </button>
                        &nbsp;&nbsp;
                        <button mat-stroked-button color="primary" (click)="resetForm()"
                            i18n="@@login-one-time.form.reset-button.label">
                            login-one-time.form.reset-button.label
                        </button>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="showSubmitSpinner">
                        <mat-spinner color="accent" diameter="32"></mat-spinner>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="normal-paragraph-spacing"
                        *ngIf="showExpiredTemporaryPasswordError">
                        <a (click)="forgotPassword()" class="anchor-link accent-color-important"
                            i18n="@@login-one-time.form.forgot-password-link.label">login-one-time.form.forgot-password-link.label</a>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                        class="display-text warning-color normal-paragraph-spacing" *ngIf="showSubmitError">
                        <b><span
                                i18n="@@login-one-time.submit-message.error.1">login-one-time.submit-message.error.1</span></b>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" style="text-align: center;"
                        class="display-text warning-color normal-paragraph-spacing" *ngIf="showSubmitError">
                        <b><span
                                i18n="@@login-one-time.submit-message.error.2">login-one-time.submit-message.error.2</span></b>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center"
                        class="display-text highlighted-display-text normal-paragraph-spacing" *ngIf="showLoginButton">
                        <b><span
                                i18n="@@login-one-time.submit-message.success.1">login-one-time.submit-message.success.1</span></b>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center"
                        class="display-text highlighted-display-text normal-paragraph-spacing" *ngIf="showLoginButton">
                        <b><span
                                i18n="@@login-one-time.submit-message.success.2">login-one-time.submit-message.success.2</span></b>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing"
                        *ngIf="showLoginButton">
                        <button mat-flat-button color="primary" (click)="openLogin()"
                            i18n="@@login-one-time.form.login-button.label">
                            login-one-time.form.login-button.label
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-template>
